import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import GuidanceAccordion from "../components/guidance/GuidanceAccordion";
import GuidanceBulletList from "../components/guidance/GuidanceBulletList";

function GeneralGuidancePage() {
  const { t } = useTranslation();

  return (
    <div className="w-full max-w-lg h-full min-h-0 overflow-y-auto p-4">
      <section className="min-h-full flex flex-col gap-2">
        <header className="flex flex-col items-start text-start gap-1">
          <h1 className="subtitle-text">
            {t("guidance.general.title", "General recording tips")}
          </h1>
          <p className="">
            {t(
              "guidance.general.intro",
              "Use these tips for any recording mode.",
            )}
          </p>
        </header>

        <GuidanceAccordion
          title={t("guidance.general.camera.title", "Camera setup")}
          defaultOpen
        >
          <GuidanceBulletList
            items={[
              t(
                "guidance.general.camera.stable",
                "Place your phone on a stable surface and keep it hands-free.",
              ),
              t(
                "guidance.general.camera.clean",
                "Check the camera lens is clean and not covered.",
              ),
              t(
                "guidance.general.camera.frame",
                "Follow the on-screen framing instructions for the selected recording mode.",
              ),
            ]}
          />
        </GuidanceAccordion>

        <GuidanceAccordion
          title={t("guidance.general.environment.title", "Environment")}
        >
          <GuidanceBulletList
            items={[
              t(
                "guidance.general.environment.light",
                "Use steady lighting and avoid glare, strong shadows, or a bright window behind you.",
              ),
              t(
                "guidance.general.environment.quiet",
                "Choose a quiet space where you can remain still until the recording finishes.",
              ),
              t(
                "guidance.general.environment.surface",
                "Avoid placing the phone somewhere it may wobble or vibrate.",
              ),
            ]}
          />
        </GuidanceAccordion>

        <GuidanceAccordion
          title={t("guidance.general.during.title", "During the recording")}
        >
          <GuidanceBulletList
            items={[
              t(
                "guidance.general.during.still",
                "Stay still unless the recording mode asks you to perform a specific action.",
              ),
              t(
                "guidance.general.during.prompts",
                "Follow the on-screen prompts and wait until the app says the recording is complete.",
              ),
              t(
                "guidance.general.during.retry",
                "If the app asks you to repeat the recording, reset your position before trying again.",
              ),
            ]}
          />
        </GuidanceAccordion>

        <GuidanceAccordion
          title={t(
            "guidance.general.upload.title",
            "If a recording does not upload",
          )}
        >
          <GuidanceBulletList
            items={[
              t(
                "guidance.general.upload.wifi",
                "Connect to Wi-Fi before trying to upload again.",
              ),
              t(
                "guidance.general.upload.stayOpen",
                "Keep the app open until the upload has completed.",
              ),
              t(
                "guidance.general.upload.signal",
                "If Wi-Fi is not available, move to an area with a stronger mobile data signal and try again.",
              ),
            ]}
          />
        </GuidanceAccordion>
      </section>
    </div>
  );
}

export default memo(GeneralGuidancePage);
